import axiosInstance from "./axios";

// FETCH APIS

export const fetchEmojiIcons = async (value) => {
  try {
    const res = await axiosInstance.get(
      `user/font-awesome-icon-search/${value}`
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserCardDetails = async ({ id }) => {
  try {
    const res = await axiosInstance.get(`user/user-card/${id}`);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchSubscriptionPlans = async () => {
  try {
    const res = await axiosInstance.get(`user/subscription-plans`);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchCompanyUser = async (value) => {
  try {
    const res = await axiosInstance.get(`company/${value}`);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};
export const fetchUserInfo = async () => {
  try {
    const res = await axiosInstance.get(`user/user`);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchLocationDetails = async ({ lng, lat, accessToken }) => {
  const response = await fetch(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${accessToken}`
  );
  const data = await response.json();
  return data.features[0] ? data.features[0].place_name : "Unknown location";
};

export const fetchIsochrone = async ({ lng, lat, accessToken, minutes }) => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/isochrone/v1/mapbox/driving/${lng},${lat}?contours_minutes=${minutes}&polygons=true&access_token=${accessToken}`
    );
    const data = await response.json();
    return data;
  } catch (e) {
    return e;
  }
};

export const getUserMap = async ({ id }) => {
  try {
    const res = await axiosInstance.get(`user/user-map/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getUserMapFolders = async ({ id = "" }) => {
  try {
    const res = await axiosInstance.get(`user/user-map-folder/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// POST APIS

export const fetchUserBilling = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/user-billing`, body);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const generateDemographicReport = async ({ body, params }) => {
  return axiosInstance.post(
    `report/generate-report`,
    { ...body, isCrimeRisk: true },
    {
      params: params,
      responseType: "blob",
    }
  );
};

export const postImageSearch = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`poi/image-search`, body);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const postRefreshToken = async (refreshToken) => {
  try {
    const res = await axiosInstance.post("auth/refreshToken", {
      refreshToken,
      isCrimeRisk: true,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserMap = async ({ id, body }) => {
  try {
    const res = await axiosInstance.post(`user/user-map/${id}`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createUserMap = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/user-map`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUserMapFolders = async ({ id, body }) => {
  try {
    const res = await axiosInstance.post(`user/user-map-folder/${id}`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserInfo = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/update-user`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserPassword = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/change-password`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createUserMapFolder = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/user-map-folder-create`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const mapLogoUpload = ({ params, body, conifg = {} }) => {
  return axiosInstance.post(
    `user/map-logo-upload${params ? params : ""}`,
    body,
    conifg
  );
};

export const uploadUserLogo = ({ body, config = {} }) => {
  return axiosInstance.post(`user/upload`, body, config);
};

export const addUserCard = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/user-card`, body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const cancelUserAutoRenewalSub = async ({ body }) => {
  try {
    const res = await axiosInstance.post(
      `user/cancel-auto-renewal-subscription`,
      body
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const createUserSubscription = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/create-subscription`, body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const verifyImpersonateToken = async ({ body }) => {
  return axiosInstance.post("auth/verify-impersonate-token", body);
};

export const duplicateUserMap = async ({ body }) => {
  try {
    const res = await axiosInstance.post(`user/user-map`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// PUT APIS

export const updateUserMapFolder = async ({ body }) => {
  try {
    const res = await axiosInstance.put(`user/user-map-folder`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserMap = async ({ body }) => {
  try {
    const res = await axiosInstance.put(`user/user-map`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserCard = async ({ body }) => {
  try {
    const res = await axiosInstance.put(`user/user-card`, body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

// DELETE APIS

export const deleteUserMapFolder = async ({ id }) => {
  try {
    const res = await axiosInstance.delete(`user/user-map-folder/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserMap = async ({ id }) => {
  try {
    const res = await axiosInstance.delete(`user/user-map/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserCard = async ({ id, cardId }) => {
  try {
    const res = await axiosInstance.delete(
      `user/delete-user-card/${id}/${cardId}`
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
